import {useAppSelector, useAppSettings} from "../../hook";

export function useAccessRights(): boolean {
    const token = useAppSelector(state => !!state.auth.token);
    const {allowGuestAccess} = useAppSettings();

    return token || allowGuestAccess;
}
  
  